<!-- eslint-disable max-len -->
<template>
  <div
    :style="{
      height: (inModal ? '100%' : '84%'),
    }"
  >
    <ul
      v-if="useInternalHelp"
      class="navbar-nav ml-auto"
      style="align-items: start; position: relative; top: -10px; height: 25px;"
      :style="{
        top: (inModal ? '-10px' : '-25px'),
      }"
    >
      <support-ticket-input button-text="Contact Support" pill-button />
    </ul>
    <form
      @submit="searchForArticles"
    >
      <div class="form-row" style="margin: -2px 1% 23px; width: 98%;">
        <b-input-group
          style="
            flex-basis: 100px;
            flex-grow: 1;
            height: 35px;
            outline: none !important;
            max-width: 70%;
          "
        >
          <b-breadcrumb
            :items="breadcrumbs"
            style="
              background: none;
              flex-wrap: nowrap;
              white-space: nowrap;
            "
            @click="breadcrumbClick"
          ></b-breadcrumb>
        </b-input-group>
        <b-input-group style="flex-basis: 100px; flex-grow: 1; max-width: 30%;">
          <b-input-group-prepend>
            <b-input-group-text
              style="background: white; border-radius: 16px 0 0 16px; border-right: rgba(0,0,0,0); padding-right: 4px;"
            >
              <i class="fas fa-search"></i>
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            v-model="searchInput"
            placeholder="Search For Support Articles"
            style="border-radius: 0 16px 16px 0; border-left: rgba(0,0,0,0);"
            type="search"
            @input="() => { if (!searchInput) resetSearch(); }"
          />
        </b-input-group>
        <div
          class="btn"
          style="margin: 2px 0px 2px 3px; height: 100%;"
          @click="searchForArticles"
          tabindex="0"
        >Search</div>
        <div
          class="btn"
          style="margin: 2px 3px; height: 100%;"
          @click="resetSearch"
          tabindex="0"
        >Reset</div>
      </div>
    </form>
    <div
      class="article-navigator"
      :class="{
        'in-modal': inModal,
      }"
      style="display: flex; flex-flow: row nowrap; width: 100%; overflow-x: auto;"
    >
      <div
        v-if="searchResults && searchResults.length > 0"
        :style="{
          display: 'flex',
          'flex-flow': 'column nowrap',
          'flex-basis': '100px',
          'flex-grow': 1,
          padding: '0 7px',
          'max-width': `${(selectedArticle ? 25 : 100)}%`,
          transition: 'max-width 0.75s ease-in-out',
          'overflow-y': 'auto',
          'max-height': '100%',
        }"
      >
        <div
          v-for="(article, k) in searchResults"
          :key="`content-article${k}`"
          class="btn-faq-article"
          :class="{
            'btn-faq-article-unselected':
              activeEnvironment.articleButtonUnselectedColor
              && !(selectedArticle && `${selectedArticle._id}` === `${article._id}`),
          }"
          style="max-width: calc(100% - 20px); margin-left: 10px; flex-shrink: 0; height: fit-content;"
          :style="(selectedArticle && `${selectedArticle._id}` === `${article._id}`)
            ? 'outline: 3px solid black;'
            : (selectedArticle ? 'filter: brightness(0.825) contrast(120%);' : '')"
          @click="articleSelected(0, article)"
          tabindex="0"
        >
          <div style="padding: 0 0 2px;">
            <div
              v-html="article.title"
              style="font-size: 19px; line-height: 23px; margin: 2px 1px;"
            ></div>
            <div
              v-if="article.subtitle"
              v-html="article.subtitle"
              style="margin: 1px;"
            ></div>
          </div>
        </div>
      </div>
      <template
        v-else-if="
          selectedCategoriesContent.length !== 1
          || selectedArticle
          || selectedCategoriesContent[0].articleCategories.length > 4
          || selectedCategoriesContent[0].articles.length > 0
        "
      >
        <div
          v-for="(category, i) in selectedCategories"
          :key="`category${i}`"
          :style="{
            display: 'flex',
            'flex-flow': 'column nowrap',
            'flex-basis': (category ? '100px' : '0px'),
            'flex-grow': (category ? 1 : 0),
            padding: (category ? '0 7px' : 0),
            'max-width': `${
              category
                ? ((i + 1 < selectedCategories.findIndex(v => v === 0))
                  ? ((i + 2 < selectedCategories.findIndex(v => v === 0)
                    || (i + 1 < selectedCategories.findIndex(v => v === 0) && selectedArticle))
                    ? 0
                    : 25)
                  : 100)
                : 0
              }%`,
            opacity:
              (i + 2 < selectedCategories.findIndex(v => v === 0)
              || (i + 1 < selectedCategories.findIndex(v => v === 0) && selectedArticle))
                ? 0
                : 1,
            transition: 'all 0.75s ease-in-out',
            'overflow-y': 'auto',
            'max-height': '100%',
          }"
        >
          <template
            v-if="selectedCategoriesContent[i]
              && (selectedCategoriesContent[i].articleCategories && selectedCategoriesContent[i].articles)
              && (selectedCategoriesContent[i].articleCategories.length > 0 || selectedCategoriesContent[i].articles.length > 0)"
          >
            <div
              v-if="(selectedCategoriesContent[i].articleCategories.length > 0 && selectedCategoriesContent[i].articles.length > 0)"
            >Categories</div>
            <div
              v-for="(subcategory, j) in selectedCategoriesContent[i].articleCategories"
              :key="`content-category${j}`"
              class="btn-faq-category"
              :class="{
                'btn-faq-category-unselected':
                  activeEnvironment.categoryButtonUnselectedColor
                  && !(selectedCategories.some(c => `${c._id}` === `${subcategory._id}`)),
              }"
              style="width: calc(100% - 20px); margin-left: 10px; flex-shrink: 0; height: fit-content;"
              :style="selectedCategories.some(c => `${c._id}` === `${subcategory._id}`)
                ? 'outline: 3px solid black;'
                : (selectedCategories.length > i + 1 ? 'filter: brightness(0.825) contrast(120%);' : '')"
              @click="categorySelected(i, subcategory)"
              tabindex="0"
            >
              <div style="padding: 0 0 2px;">
                <div
                  v-html="subcategory.title"
                  style="font-size: 19px; line-height: 23px; margin: 2px 1px;"
                ></div>
                <div
                  v-if="subcategory.description"
                  v-html="subcategory.description"
                  style="margin: 1px;"
                ></div>
              </div>
            </div>
            <div
              v-if="(selectedCategoriesContent[i].articleCategories.length > 0 && selectedCategoriesContent[i].articles.length > 0)"
            >Articles</div>
            <div
              v-for="(article, k) in selectedCategoriesContent[i].articles"
              :key="`content-article${k}`"
              class="btn-faq-article"
              :class="{
                'btn-faq-article-unselected':
                  activeEnvironment.articleButtonUnselectedColor
                  && !(selectedArticle && `${selectedArticle._id}` === `${article._id}`),
              }"
              style="width: calc(100% - 20px); margin-left: 10px; flex-shrink: 0; height: fit-content;"
              :style="(selectedArticle && `${selectedArticle._id}` === `${article._id}`)
                ? 'outline: 3px solid black;'
                : ((selectedArticle && selectedCategories.length > i) ? 'filter: brightness(0.825) contrast(120%);' : '')"
              @click="articleSelected(i, article)"
              tabindex="0"
            >
              <div style="padding: 0 0 2px;">
                <div
                  v-html="article.title"
                  style="font-size: 19px; line-height: 23px; margin: 2px 1px;"
                ></div>
                <div
                  v-if="article.subtitle"
                  v-html="article.subtitle"
                  style="margin: 1px;"
                ></div>
              </div>
            </div>
          </template>
          <div v-else-if="selectedCategoriesContent[i]">This category has no content.</div>
          <div v-else-if="category">Loading content...</div>
        </div>
        <!-- <div
          v-for="(filler, i) in [1,1,1,1]"
          :key="`category${i + selectedCategories.length}`"
          :style="{
            display: 'flex',
            'flex-flow': 'column nowrap',
            'flex-basis': '0px',
            'flex-grow': 0,
            padding: 0,
            'max-width': 0,
            transition: 'max-width 1s',
          }"
        >
        </div> -->
      </template>
      <template v-else>
        <div
          v-for="(category, i) in selectedCategoriesContent[0].articleCategories"
          :key="`rootcategory${i}`"
          :style="{
            display: 'flex',
            'flex-flow': 'column nowrap',
            'flex-basis': (category ? '100px' : '0px'),
            'flex-grow': (category ? 1 : 0),
            padding: (category ? '0 7px' : 0),
            'max-width': '100%',
            opacity: 1,
            transition: 'all 0.75s ease-in-out',
            'max-height': '100%',
          }"
        >
          <div
            style="font-size: 26px; margin: 3px 0 10px;"
            v-html="category.title"
          ></div>
          <div
            v-if="category.description"
            style="font-size: 14px; margin: -8px 0 15px;"
            v-html="category.description"
          ></div>
          <template
            v-if="rootLevelCategoriesContent[i]
              && (rootLevelCategoriesContent[i].articleCategories && rootLevelCategoriesContent[i].articles)
              && (rootLevelCategoriesContent[i].articleCategories.length > 0 || rootLevelCategoriesContent[i].articles.length > 0)"
          >
            <div style="overflow-y: auto;">
              <div
                v-if="(rootLevelCategoriesContent[i].articleCategories.length > 0 && rootLevelCategoriesContent[i].articles.length > 0)"
              >Categories</div>
              <div
                v-for="(subcategory, j) in rootLevelCategoriesContent[i].articleCategories"
                :key="`content-category${j}`"
                class="btn-faq-category btn-faq-category-unselected"
                style="width: calc(100% - 20px); margin-left: 10px; flex-shrink: 0; height: fit-content;"
                @click="categorySelected(0, subcategory, i)"
                tabindex="0"
              >
                <div style="padding: 0 2px 2px 0;">
                  <div
                    v-html="subcategory.title"
                    style="font-size: 19px; line-height: 23px; margin: 2px 1px;"
                  ></div>
                  <div
                    v-if="subcategory.description"
                    v-html="subcategory.description"
                    style="margin: 1px;"
                  ></div>
                </div>
              </div>
              <div
                v-if="(rootLevelCategoriesContent[i].articleCategories.length > 0 && rootLevelCategoriesContent[i].articles.length > 0)"
              >Articles</div>
              <div
                v-for="(article, k) in rootLevelCategoriesContent[i].articles"
                :key="`content-article${k}`"
                class="btn-faq-article"
                :class="{
                  'btn-faq-article-unselected':
                    activeEnvironment.articleButtonUnselectedColor
                    && !(selectedArticle && `${selectedArticle._id}` === `${article._id}`),
                }"
                style="width: calc(100% - 20px); margin-left: 10px; flex-shrink: 0; height: fit-content;"
                @click="articleSelected(0, article, i)"
                tabindex="0"
              >
                <div style="padding: 0 2px 2px 0;">
                  <div
                    v-html="article.title"
                    style="font-size: 19px; line-height: 23px; margin: 2px 1px;"
                  ></div>
                  <div
                    v-if="article.subtitle"
                    v-html="article.subtitle"
                    style="margin: 1px;"
                  ></div>
                </div>
              </div>
            </div>
          </template>
          <div v-else-if="rootLevelCategoriesContent[i]">This category has no content.</div>
          <div v-else-if="category">Loading content...</div>
        </div>
      </template>
      <div
        :style="{
          'flex-basis': '200px',
          'flex-grow': 3,
          padding: '0 6px',
          'max-width': `${(selectedArticle ? 100 : 0)}%`,
          transition: 'max-width 0.75s ease-in-out',
          'overflow-y': 'auto',
          'max-height': '100%',
        }"
      >
        <div
          v-if="selectedArticle"
          v-html="selectedArticle.title"
          style="font-size: 23px; line-height: 25px; margin: 3px 1px;"
        ></div>
        <div
          v-if="selectedArticle && selectedArticle.subtitle"
          v-html="selectedArticle.subtitle"
          style="font-size: 15px; line-height: 16px; margin: 1px 1px 4px;"
        ></div>
        <div
          v-if="selectedArticle && selectedArticle.author"
          v-html="selectedArticle.author"
          style="font-size: 14px; line-height: 16px; margin: 8px 1px;"
        ></div>
        <div
          v-if="selectedArticle && (selectedArticle.lastUpdatedOverride || articleUpdatedString)"
          v-html="selectedArticle.lastUpdatedOverride || articleUpdatedString"
          style="font-size: 13px; line-height: 16px; margin: 1px;"
        ></div>
        <div
          v-if="selectedArticle"
          v-html="selectedArticle.body"
          style="font-size: 14px; line-height: 18px; margin: 16px 1px 2px;"
        ></div>
        <ul
          v-if="selectedArticle && selectedArticle.appendTicketRequestButton"
          class="navbar-nav ml-auto"
          style="margin: 8px auto; max-width: 125px;"
        >
          <support-ticket-input button-text="Contact Support" pill-button />
        </ul>
      </div>
    </div>
    <!-- {{ selectedCategories }}
    {{ selectedArticle }} -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import SupportTicketInput from './SupportTicketInput';
import TextInput from '../../ui/inputs/TextInput';

export default {
  components: {
    SupportTicketInput,
    TextInput,
  },

  props: {
    inModal: Boolean,
  },

  async mounted() {
    const {
      article: startingSelectedArticleId,
      cat: categoriesParam,
    } = this.$route.query;
    const startingSelectedCategoryIds =
      categoriesParam
        ? (Array.isArray(categoriesParam) ? categoriesParam : [categoriesParam])
        : undefined;
    this.selectedArticle =
      startingSelectedArticleId
        ? await this.getArticleContent({ articleId: startingSelectedArticleId })
        : null;

    this.selectedCategories = [
      { _id: null },
      ...(startingSelectedCategoryIds
        ? startingSelectedCategoryIds.map(sscId => ({ _id: sscId }))
        : []),
    ];
    // a max of 10 category columns, prepopulated so that CSS transitions can work fully
    while (this.selectedCategories.length < 10) {
      this.selectedCategories.push(0);
    }
    this.selectedCategoriesContent = await Promise.all([
      this.getCategoryContent({ articleCategoryId: null }),
      ...(startingSelectedCategoryIds
        ? startingSelectedCategoryIds.map(sscId => this.getCategoryContent({ articleCategoryId: sscId }))
        : []),
    ]);
    if (startingSelectedCategoryIds) {
      // post-process
      this.fixStartingSelectedCategories(startingSelectedCategoryIds);
      this.refreshBreadcrumbs();
    }
    if (this.selectedCategoriesContent[0]
      && this.selectedCategoriesContent[0].articles.length === 0
      && this.selectedCategoriesContent[0].articleCategories.length < 4) {
      this.rootLevelCategoriesContent =
        await Promise.all(
          this.selectedCategoriesContent[0].articleCategories.map(
            category => this.getCategoryContent({ articleCategoryId: category._id })
          )
        );
    }
  },

  data() {
    return {
      // a max of 10 category columns, prepopulated so that CSS transitions can work fully
      selectedCategories: [{ _id: null }, 0, 0, 0, 0, 0, 0, 0, 0, 0], // [{ _id: null }],
      selectedCategoriesContent: [],
      rootLevelCategoriesContent: [],
      selectedArticle: null,
      searchInput: '',
      searchResults: [],
      breadcrumbs: [
        {
          text: 'All',
          href: '#',
          active: false,
        },
      ]
    };
  },

  computed: {
    ...mapGetters([
      'activeSignInConfig',
      'activeEnvironment',
      'canManageUsers',
      'me',
    ]),
    isValid() {
      return this.imageUrl && this.imageUrl.length > 0
          && this.description && this.description.length > 0
          && !this.capturingScreenshot
      ;
    },
    shouldUseSignInSettings() {
      return !(this.$route.meta && this.$route.meta.doNotUseSignInForNavbar)
        && ((this.$route.meta && this.$route.meta.useSignInForNavbar)
          || !(this.$route.path.startsWith('/groups/')));
    },
    useInternalHelp() {
      if (this.shouldUseSignInSettings) {
        const config = this.activeSignInConfig;
        if (config) {
          return config.useInternalHelp;
        }
      }
      return this.activeEnvironment.useInternalHelp;
    },
    articleUpdatedString() {
      return this.selectedArticle ? `Updated ${(new Date(this.selectedArticle.updated)).toLocaleDateString()}` : '';
    },
  },

  // these watchers are only needed to make back/forward navigation work as expected
  watch: {
    '$route.query.article': async function(newValue) {
      if (this.selectedArticle && `${this.selectedArticle._id}` !== newValue
        || (!(this.selectedArticle) && newValue)) {
        console.log('selected article out of sync with url; update');
        this.selectedArticle =
          newValue
            ? await this.getArticleContent({ articleId: newValue })
            : null;
      }
    },
    '$route.query.cat': async function(newValue) {
      const startingSelectedCategoryIds =
      newValue
        ? (Array.isArray(newValue) ? newValue : [newValue])
        : [];
      const currentCat = this.selectedCategories.filter(c => c && c._id).map(c => c._id);
      const catInSync =
        startingSelectedCategoryIds.length === currentCat.length
          && startingSelectedCategoryIds.every((sscId, i) => sscId === currentCat[i]);
      if (!catInSync) {
        console.log('selected categories out of sync with url; update');
        // clear out excess categories
        if (startingSelectedCategoryIds.length < currentCat.length) {
          this.selectedCategoriesContent.splice(startingSelectedCategoryIds.length + 1);
          for (let i = startingSelectedCategoryIds.length + 1; i < this.selectedCategories.length; ++i) {
            this.selectedCategories[i] = 0;
          }
        }
        // fetch missing categories
        // eslint-disable-next-line no-unused-vars
        const contentPromises = startingSelectedCategoryIds.map(_ => new Promise(resolve => resolve(null)));
        for (let i = 0; i + 1 < this.selectedCategories.length && i < startingSelectedCategoryIds.length; ++i) {
          const catIndex = i + 1;
          if (!(this.selectedCategories[catIndex] && this.selectedCategories[catIndex]._id)
            || `${this.selectedCategories[catIndex]._id}` !== startingSelectedCategoryIds[i]) {
            // missing, fetch
            this.selectedCategories[catIndex] = { _id: startingSelectedCategoryIds[i] };
            contentPromises[i] = this.getCategoryContent({ articleCategoryId: startingSelectedCategoryIds[i] });
          }
        }
        const content = await Promise.all(contentPromises);
        content.forEach((con, i) => {
          if (con) {
            if (this.selectedCategoriesContent.length > i + 1) {
              this.selectedCategoriesContent[i + 1] = con;
            } else {
              this.selectedCategoriesContent.push(con);
            }
          }
        });
        this.fixStartingSelectedCategories(startingSelectedCategoryIds);
        this.refreshBreadcrumbs();
      }
    },
  },

  methods: {
    ...mapActions([
      'getCategoryContent',
      'getArticleContent',
      'searchArticles',
    ]),
    ...mapMutations([
      'setRootLoadingMessage',
    ]),
    deselectToIndex(index, updateNavigationalQueryParams = true) {
      this.selectedArticle = null;

      // this.selectedCategories = this.selectedCategories.slice(0, index + 1);
      for (let i = index + 1; i < this.selectedCategories.length; ++i) {
        this.selectedCategories[i] = 0;
      }

      this.selectedCategoriesContent = this.selectedCategoriesContent.slice(0, index + 1);

      if (index !== 0) {
        this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);
      } else {
        this.breadcrumbs = this.breadcrumbs.slice(0, 1);
      }

      if (updateNavigationalQueryParams) {
        this.updateNavigationalQueryParams();
      }
    },
    rootCategorySelected(rootCategoryIndex) {
      const category = this.selectedCategoriesContent[0].articleCategories[rootCategoryIndex];
      this.selectedCategories[1] = category;

      this.selectedCategoriesContent.push(this.rootLevelCategoriesContent[rootCategoryIndex]);

      this.breadcrumbs.push({
        text: category.title.replace(/<\/?[^>]+(>|$)/g, ''), // TODO: proper sanitization
        href: '#',
        active: false,
      });

      // no updating navigational query params here because the caller should handle that
    },
    async categorySelected(currentIndex, category, rootCategoryIndex = null) {
      this.deselectToIndex(currentIndex, false);
      this.searchInput = '';

      if (rootCategoryIndex != null) {
        this.rootCategorySelected(rootCategoryIndex);
        await this.categorySelected(currentIndex + 1, category);
      } else {
        // this.selectedCategories.push(category);
        this.selectedCategories[currentIndex + 1] = category;

        this.selectedCategoriesContent.push(await this.getCategoryContent({ articleCategoryId: category._id }));

        this.breadcrumbs.push({
          text: category.title.replace(/<\/?[^>]+(>|$)/g, ''), // TODO: proper sanitization
          href: '#',
          active: false,
        });

        this.updateNavigationalQueryParams();
      }
    },
    async articleSelected(currentIndex, article, rootCategoryIndex = null) {
      this.deselectToIndex(currentIndex, false);
      if (rootCategoryIndex != null) {
        this.rootCategorySelected(rootCategoryIndex);
        await this.articleSelected(currentIndex + 1, article);
      } else {
        this.selectedArticle = article;
        this.selectedArticle = await this.getArticleContent({ articleId: article._id });
        // this.selectedArticle.body = articleContent.body;

        this.updateNavigationalQueryParams();
      }
    },
    updateNavigationalQueryParams() {
      if (this.$route.path === '/helpcenter') {
        const newQueryParams = Object.assign({}, this.$route.query);
        newQueryParams.cat = this.selectedCategories.filter(c => c && c._id).map(c => c._id);
        newQueryParams.article = this.selectedArticle ? this.selectedArticle._id : undefined;
        this.$router.push({ path: this.$route.path, query: newQueryParams });
      }
    },
    refreshBreadcrumbs() {
      this.breadcrumbs.splice(1); // clear all but root breadcrumb
      this.selectedCategories.forEach((cat) => {
        if (cat && cat.title) {
          this.breadcrumbs.push({
            text: cat.title.replace(/<\/?[^>]+(>|$)/g, ''), // TODO: proper sanitization
            href: '#',
            active: false,
          });
        }
      });
    },
    /** starting selected categories only have _id, this copies the other info */
    fixStartingSelectedCategories(startingSelectedCategoryIds) {
      startingSelectedCategoryIds.forEach((sscId, i) => {
        if (this.selectedCategoriesContent.length > i
          && this.selectedCategoriesContent[i]
          && this.selectedCategoriesContent[i].articleCategories) {
          const category = this.selectedCategoriesContent[i].articleCategories.find(c => c._id === sscId);
          if (category && category.title) {
            this.selectedCategories[i + 1] = category;
          }
        }
      });
    },
    async searchForArticles(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.deselectToIndex(0);
      if (this.searchInput) {
        this.searchResults = await this.searchArticles({ searchInput: this.searchInput });
      } else {
        this.searchResults = [];
      }
    },
    resetSearch(evt) {
      this.selectedArticle = null;
      this.searchInput = '';
      this.searchForArticles(evt);
    },
    breadcrumbClick(evt) {
      if (evt && evt.target && evt.target.innerText) {
        const index = this.breadcrumbs.findIndex(b => b.text === evt.target.innerText);
        if (index >= 0) {
          this.deselectToIndex(index);
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.env-dropdown-content
{
  color: white;
  padding: 10px;
  width: 350px;
  max-height: 500px;
  overflow-y: auto;
}

header {
  height: 40px;
}
.navbar-root {
  height: 100%;
  padding-top: 4px;

  .nav-link {
    color: var(--navBarTextColor) !important;
    margin: 0 2px;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    // text-transform: lowercase;
    font-weight: 100;
  }
  .nav-link:hover {
    // background-color: rgba(0, 0, 7, 0.2);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-item {
    color: var(--navBarTextColor) !important;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-transform: lowercase;
    font-weight: 100;
  }
  .dropdown-item:hover {
    // background-color: rgba(0, 0, 7, 0.4);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-divider {
    border-color: var(--primaryColor);
  }

  .username {
    text-transform: unset !important;
  }
}

.navbar-bg {
  // background-color: rgba(0, 0, 7, 0.76);
  background-color: var(--navBarDropdownColor);
}

.navbar-logo {
  width: 50%;
  height: 100%;
  position: relative;
}
.logo-link {
  outline-color: white;
  height: 100%;
  margin-left: 10px;
}
.logo {
  height: 100%;
  max-width: 100%;
  object-fit: contain;
}
.navbar-brandText {
  color: var(--navBarTextColor);
  outline-color: white;
  width: auto;
  height: 100%;
  margin: auto;
  margin-top: -2px;
  text-align: center;
  white-space: nowrap;
  font-size: 16pt;
  font-weight: bold;
  font-family: unset;
  // font-weight: normal;
  // font-family: "Book Antiqua", Palatino, serif;
}
.navbar-actionItems {
  width: 50%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.navbar-brand:focus, .nav-item a:focus {
  outline-color: white;
}
.title {
  color: var(--primaryColor);
  background-color: white;
  font-size: 72px;
  font-weight: bold;
  border-radius: 0;
  margin: 0;
  padding: 40px;
}
.demo-links {
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
}
.demo-link {
  color: black;
  padding: 2px 5px;
}
.demo-link:hover, .demo-link:focus {
  text-decoration: none;
  color: var(--primaryColor);
}
.demo-link:focus {
  outline: none;
}

.dropdown-toggle[aria-expanded="true"]:after {
  transform: rotate(180deg);
}
.dropdown-toggle:after {
  transition: 0.4s;
}

.navbar-item-divider {
  //width: 1.3px;
  //background-color: var(--primaryColor);
  // Doing it with border rather than width because borders tend to render thin lines more cleanly
  // across different browsers
  height: 72%;
  width: 0px;
  margin: 5px 4px;
  border-right: 1px solid var(--primaryColor);
}

.state-list-item {
  display: flex;
  margin-bottom: 10px;
  padding: 5px;
  //border: 1px solid rgba(255,255,255,0.3);
  background-color: rgba(17,17,17,0.8);
}

.state-list-item-text {
  flex-basis: 100%;
}

.article-navigator {
  min-height: calc(100% - 63px);
  max-height: calc(100% - 63px);
}

.article-navigator.in-modal {
  min-height: calc(96% - 63px);
  max-height: calc(96% - 63px);
}

@media only screen and (max-height: 575.98px) and (orientation: landscape) {
  .article-navigator.in-modal {
    min-height: calc(93% - 81px);
    max-height: calc(93% - 81px);
  }
}

@media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
  .article-navigator.in-modal {
    min-height: calc(89% - 63px);
    max-height: calc(89% - 63px);
  }
}

.article-navigator * {
  scrollbar-color: var(--buttonColor) rgba(17, 17, 17, 0.5);
  scrollbar-width: thin;
}

.article-navigator *::-webkit-scrollbar {
  width: 14px;
}

.article-navigator *::-webkit-scrollbar-track {
  background: rgba(17, 17, 17, 0.5);
  border-radius: 10px;
}

.article-navigator *::-webkit-scrollbar-thumb {
  background: var(--buttonColor);
  border-radius: 10px;
}

.input-group:focus-within {
  outline: 2px solid #86b7fe;
  border-radius: 16px;
}
.input-group .form-control:focus {
  box-shadow: none !important;
}

@media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
  .article-navigator {
    max-height: 62vw;
    min-height: 62vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/display/SupportArticleViewer.vue